import { motion } from 'framer-motion';
import { Truck, Droplets, Shirt, PackageCheck } from 'lucide-react';
import { useI18n } from '../lib/i18n';
import { TIDS } from '../constants/testIds';

const ICONS = {
  pickup: Truck,
  wash: Droplets,
  fold: Shirt,
  delivery: PackageCheck,
};

const Services = () => {
  const { t } = useI18n();

  return (
    <section
      id="services"
      data-testid={TIDS.servicesSection}
      className="py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#1D1D1F] leading-tight">
            {t.services.title}
          </h2>
          <p className="mt-5 text-lg sm:text-xl text-[#86868B] font-medium leading-relaxed">
            {t.services.subtitle}
          </p>
        </motion.div>

        <div className="mt-14 sm:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[item.key];
            return (
              <motion.div
                key={item.key}
                data-testid={TIDS.serviceCard(item.key)}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group relative bg-[#F5F5F7] rounded-[2rem] p-8 sm:p-10 transition-all duration-300 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] hover:-translate-y-1"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-white shadow-sm">
                  <Icon className="w-6 h-6 text-[#0071E3]" strokeWidth={2} />
                </div>
                <h3 className="mt-6 text-2xl font-bold tracking-tight text-[#1D1D1F]">
                  {item.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#86868B]">
                  {item.desc}
                </p>
                <div className="absolute top-6 right-6 text-[11px] font-semibold tracking-wider text-[#86868B]/60">
                  0{i + 1}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
